import { urls } from '../constants'
import api from './api'

const loginUser = async ({ email, password }) => {
  try {
    const response = await api.post(urls.login, {
      username: email,
      password
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      response: error.response?.data || { error: { message: "Error al conectar con el servidor" } }
    };
  }
};

const addUser = async ({ user }) => {
  try {
    const response = await api.post(urls.addUser, user);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const getUsers = async ({ page, limit }) => {
  try {
    const response = await api.get(urls.getUsers, {
      params: {
        roleId: '5ffdbb7cf4de1f43a4caff60',
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const getUsersFilter = async ({ text, page, limit }) => {
  try {
    const response = await api.get(urls.getUsersFilter, {
      params: {
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const updateUser = async ({ _id, user }) => {
  try {
    const response = await api.put(`${urls.updateOrDeleteUser}/${_id}`, user);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const updateUserStatus = async ({ status, _id }) => {
  try {
    const response = await api.put(`${urls.updateOrDeleteUser}/${_id}`, { status });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const deleteUser = async ({ _id, type }) => {
  try {
    const response = await api.delete(`${urls.updateOrDeleteUser}/${_id}`, {
      params: type ? { type } : {}
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const sendTokenResetPassword = async ({ email }) => {
  try {
    const response = await api.post(urls.sendTokenResetPassword, { email });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const updatePassword = async ({ token, password }) => {
  try {
    const response = await api.post(urls.updatePassword, { token, password });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const refreshToken = async ({ refreshToken }) => {
  try {
    const response = await api.post(urls.refreshToken, { refreshToken });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const logout = async ({ refreshToken }) => {
  try {
    const response = await api.post(urls.logout, { refreshToken });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const userServices = Object.freeze({
  loginUser,
  updateUser,
  addUser,
  getUsers,
  getUsersFilter,
  updateUserStatus,
  deleteUser,
  sendTokenResetPassword,
  updatePassword,
  refreshToken,
  logout
})

export default userServices;
